import { useEffect, useState, useRef } from 'react';
import { useGlobalContext } from '././GlobalProvider';
import { dryrun, message, createDataItemSigner, result  } from "@permaweb/aoconnect";
import { PermissionType } from 'arconnect';
import { GetProcessInfo, GetAllCollection, SendProcessMessage, GetBackBalance } from '../MiscTools';
import { useRive, useStateMachineInput,
    RiveEventType,
    EventType,
    Layout,
    Fit,
    Alignment,
    decodeImage,
    ImageAsset,
    FontAsset,
    FileAsset, } from '@rive-app/react-canvas';
import { RiveDemo } from './RiveDemo';
import CardDeck  from './CardDeck';
import Opponent from './Opponent';
import AccountInfo from './AccountInfo';


// Game Process:
const GAME_PROCESS = "LneuOxjmOpTHZyxWlSIWttL8QX_7FNgkjK5Ybs4E2TA";

const permissions: PermissionType[] = [
    'ACCESS_ADDRESS',
    'SIGNATURE',
    'SIGN_TRANSACTION',
    'DISPATCH'
];

interface Asset {
    Quantity: string;
    Id: string;
    Type?: string;
}

interface Choice {
    i: number;
    e: number;
}

interface PlayerStats { // Rename TurnStats
    a: number; // Attack
    s: number; // Shield
    d: number; // Damage
    m: number; // Magic
}

interface Card {
    rank: string;
    suit: string;
    rive_index: number;
    icon: string;
}

interface CardData {
    cards: Card[];
}


interface GameState {
    walletAddress: string;
    currentPlayer: string;
    turnCounter: number;
    startHeight: number;
    deck1: string[];
    deck2: string[];
    p1History: string[];
    p2History: string[];
    p1WonCards: string[];
    p2WonCards: string[];
    p1LastCards: string[];
    p2LastCards: string[];
    gameOver: boolean;
    roundWinner: string;
    gameResult: string;
    gameWinner: string;
    p1Choice: number;
    p2Choice: number;
    p1Stats: PlayerStats;
    p2Stats: PlayerStats;
    choices: Choice[];
}

function Game() {

    const {
        walletAddress,
        setWalletAddress,
        decks,
        setDecks,
      } = useGlobalContext();

    const [isConnected, setIsConnected] = useState(false);
    const [address, setAddress] = useState<string>('');
    const [profileMatch, setProfileMatch] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>("");
    const [assets, setAssets] = useState<Asset[]>([]);
    const [selectedAsset, setSelectedAsset] = useState<string>("");
    const [collectionData, setCollectionData] = useState<string>("");
    const [collectionAssets, setCollectionAssets] = useState<Asset[]>([]);
    const [matchingAssets, setMatchingAssets] = useState<Asset[]>([]);
    const [gameState, setGameState] = useState<GameState | null>(null);
    const [processReturnData, setProcessReturnData] = useState<string>("");
    const [foundGame, setFoundGame] = useState(false);
    const [speaking, setSpeaking] = useState<boolean>(false);

    const [cardData, setCardData] = useState<CardData | null>(null);
    const [lastCard, setLastCard] = useState<Card | null>(null);

    const [lastTurn, SetLastTurn] = useState<number>(0);
    const [turnLoading, setTurnLoading] = useState(false);

    const [p1DrewCard, setP1DrewCard] = useState<number>(0);

    const [opponentState, setOpponentState] = useState<number>(0);

    const audioRef = useRef<HTMLAudioElement>(null);
    const shuffleRef = useRef<HTMLAudioElement>(null);
    const warSfxRef = useRef<HTMLAudioElement>(null);
    const winSfxRef = useRef<HTMLAudioElement>(null);

    const arweaveBaseURL = "https://arweave.net/";

    const tester = useRive({
        src: './animation/ao_card_war.riv',
        stateMachines: 'MainSM',  
        autoplay: true,        
        artboard: 'Main'          
      });

      // Initialize the state machine input for "main_sm"
      const stateMachineInput = useStateMachineInput(tester.rive, 'Main', 'DrawInput');
      const p1CardIndex = useStateMachineInput(tester.rive, 'MainSM', 'p1CardIndex');

    // Fetch the JSON data and set it to state
    useEffect(() => {
        const fetchCardData = async () => {
            try {
                const response = await fetch('https://arweave.net/UTbCS_uO7jrM3puVwUqI9fySxzi5cMnJQNUxXXkzOUQ');
                const data = await response.json();
                setCardData(data);
            } catch (error) {
                console.error("Error fetching card data:", error);
            }
        };

        fetchCardData();
    }, []);

    function findMatchingIds(assets: Asset[], collectionAssets: Asset[]): string[] {
        console.log("Assets array:", assets);
        console.log("Collection Assets array:", collectionAssets);
    
        // Extract Ids from assets array
        const assetIds = assets.map(asset => asset.Id);
        console.log("Extracted asset Ids:", assetIds);
    
        // Filter collectionAssets to find matches
        const matchingIds = collectionAssets
            .filter(collectionAsset => {
                const isMatch = assetIds.includes(collectionAsset.Id);
                console.log(`Checking collectionAsset Id: ${collectionAsset.Id}, Match found: ${isMatch}`);
                return isMatch;
            })
            .map(collectionAsset => {
                console.log(`Matching collectionAsset Id: ${collectionAsset.Id}`);
                return collectionAsset.Id;
            });
    
        console.log("Final list of matching Ids:", matchingIds);
        return matchingIds;
    }

    // Reset BazAR data
    const resetWalletAssets = () => {
        setAssets([]);
        setSelectedAsset('');
        setMatchingAssets([]);
    };
    

    const checkConnected = async () => {
        console.log("Fetching address...");
        try {
            // Check if ArConnect is available
            if (window.arweaveWallet) {
                try {
                    // Request permissions if not already granted
                    const currentPermissions = await window.arweaveWallet.getPermissions();
                    console.log("Current permissions: ", currentPermissions);

                    if (!currentPermissions.includes('ACCESS_ADDRESS')) {
                        await window.arweaveWallet.connect(permissions);
                        console.log("Permissions requested.");
                    }

                    const address = await window.arweaveWallet.getActiveAddress();
                    console.log("Connected: ", address);

                    // Global 
                    setWalletAddress(address);

                    setAddress(address);
                    setIsConnected(true);

                    // Get All DumDumz 
                    const result = await GetAllCollection();
                    setCollectionData(result);

                } catch (error) {
                    console.error("Error connecting to ArConnect:", error);
                    setIsConnected(false);
                }
            } else {
                console.log("ArConnect not installed.");
                setIsConnected(false);
            }
        } catch (error) {
            console.error("Failed to fetch address:", error);
            setIsConnected(false);
        }
    };

    // BazAR ID Input
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
        // Additional logic can be added here if you want to trigger something immediately after input changes
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            // Trigger the function when "Enter" is pressed
            handleSubmit();
        }
    };

    const handleSubmit = async () => {
        if (!inputValue || inputValue.trim() === "") {
            console.log("Input value is empty or null.");
            return;
        }

        resetWalletAssets();
    
        try {
            // Call TestSend and wait for the result
            const result = await GetProcessInfo(inputValue);
    
            // Additional logic based on the result
            if (result.startsWith("Error")) {
                console.log("An error occurred:", result);
            } else {
                // console.log("Success, data received:", result);

                const parsedResult = JSON.parse(result);
                
                // Make sure the owner is the same as the connected address
                if (parsedResult.Owner !== address) {
                    setProfileMatch(false);
                    console.log("The owner of the profile is different from the connected address.");
                    return;
                } else {
                    setProfileMatch(true);
                    console.log("The owner of the profile is the same as the connected address.");
                }

                if (result && parsedResult.Assets) {
                    setAssets(parsedResult.Assets);
        
                    // Check for matching assets after setting both assets and collection data
                    // const matchingAssets = findMatchingAssets(assets, parsedResult.Assets);
                    // setMatchingAssets(matches);
                    // console.log("Matching assets:", matchingAssets);
                }

                
            }
        } catch (error) {
            console.error("There was an error during the submission process:", error);
        }
    
        console.log("Input value submitted:", inputValue);
    };

    // GetGameState
    const SendGetGameState = async () => {
        try {
            const result = await SendProcessMessage( GAME_PROCESS , 
                "GetGameState", '{}' );
    
                if( result === "Invalid data or missing wallet address" ) {
                    console.error("No game found for this wallet address.");
                    setFoundGame(false);
                } else {
                    setProcessReturnData(result);
                    setFoundGame(true);
                }

        } catch (error) {
            setFoundGame(false);
            console.error("There was an error during the submission process:", error);
            setProcessReturnData("");
        }
    };

    // Take Turn
    const SendTakeTurn = async (choiceIndex: number) => {

        setTurnLoading(true);
        setSpeaking(false);

        if( gameState ) {
            console.log("Taking Turn... " , gameState.turnCounter );
        } else {
            console.log("Starting Game...");
        }

        try {
            console.log("Player Choice: ", choiceIndex);
            const result = await SendProcessMessage(GAME_PROCESS, 
                "TakeTurn", `{"choice": "${choiceIndex}"}`);

            if( result === "Invalid data or missing wallet address" ||
                result === "No messages were returned from ao. Please try later."
             ) {
                alert(result);
            }
    
            setProcessReturnData(result);
            
        } catch (error) {
            console.error("There was an error during the submission process:", error);
            setProcessReturnData("");

            setTurnLoading(false);
            setSpeaking(false);
        }
    };

    const handleTurn = () => {
        setTimeout(() => {
          setTurnLoading(true);  // Set turnLoading to true after 1 second
        }, 1000);  // 1000 milliseconds = 1 second
      
        // Other logic you may want to execute before or after the delay
      };
      
    
    // Drop down menu
    const handleAssetsSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedAsset(e.target.value);
        console.log("Selected asset ID:", e.target.value);
    };

    // Check if connected
    useEffect(() => {
        if (isConnected) {
            console.log("Connected with address:", address);
            SendGetGameState();
        }
    }, [isConnected, address]);
    
    // DumDumz Collection
    useEffect(() => {
        if (collectionData) {
            console.log("Collection data received:", collectionData);
            
            const parsedData = JSON.parse(collectionData);
            if (parsedData.Assets) {
                setCollectionAssets(parsedData.Assets);
            }
        }
     }, [collectionData]);

     // Bazar Profile Assets
     useEffect(() => {
        if (assets) {
            
            const matchedIds = findMatchingIds(assets, collectionAssets);

            if (matchedIds.length > 0) {
                console.log("Matching IDs Found:", matchedIds);
            } else {
                console.log("No Matching IDs Found.");
            }
        }
     }, [assets]);

     // DumDumz Collection Assets
     useEffect(() => {
        if (collectionAssets) {
            console.log("collectionAssets:", collectionAssets);
        }
     }, [collectionAssets]);

    // Process Return
    useEffect(() => {
        if (processReturnData) {
            
            console.log("Process return data:", processReturnData);
            
            try {
                // Parse the gameState JSON string
                const parsedData: GameState = JSON.parse(processReturnData);
    
                // Ensure parsedData is valid and set it to gameState
                if (parsedData) {
                    console.log("parsedData:", parsedData);

                    if( parsedData.gameOver ) {
                        console.log( "Game Over: ", parsedData.gameOver , " Winner: ", parsedData.gameWinner );
                        winSfxRef.current?.play();

                        setGameState(parsedData);
                    } else { 
                        setGameState(parsedData); // Set the gameState with parsed data
                    }
                }
            } catch (e : any) {
                console.error("Error parsing game state JSON:", e.message , "" );
            }
        }
    }, [processReturnData]);
    
    useEffect(() => {
        if (gameState) {
            console.log("Game state updated:", gameState);
    
            if (gameState.p1LastCards.length > 0 && cardData) {
                const lastCardIcon = gameState.p1LastCards[gameState.p1LastCards.length - 1];
                const matchedCard = findCardByUnicodeIcon(lastCardIcon);

                if( gameState.p1LastCards.length > 1 ) {
                    shuffleRef.current?.play();
                    warSfxRef.current?.play();
                }
    
                if (matchedCard) {
                    setLastCard(matchedCard);

                    // keep this for CardDeck.tsx prop
                    setP1DrewCard(Number(matchedCard.rive_index) || 0);

                    // Set last turn
                    SetLastTurn( gameState.turnCounter );

                    setTurnLoading(false);

                    setSpeaking(true);
                }
            }
        }
    }, [gameState]);

    useEffect(() => {
        // console.log("p1DrewCard", p1DrewCard);

        // const currentValue = Number(p1CardIndex?.value) || 0;
        // console.log('Current value:', currentValue , " vs " , p1DrewCard);
        // const changeValued = Number(lastCard?.rive_index) || 0; // Fallback to 0 if undefined or not a number

        // // Perform the subtraction
        // const endValue = currentValue - changeValued;
        // const endValue2 = currentValue + endValue;
        // console.log('End value:', endValue, " vs ", endValue2);
        
        // if (p1CardIndex && typeof p1CardIndex.value === 'number') {
        //     p1CardIndex.value = p1DrewCard;  // Increment the value if it's a number
        //     console.log('p1Card_Index incremented to:', p1CardIndex.value);
        // } else {
        //     // console.error('p1Card_Index is not a number');
        // }


        // // stateMachineInput?.fire();  // Trigger the input if available
        // const value = p1CardIndex?.value;

        // if (p1CardIndex && value && typeof p1CardIndex.value === 'number') {
        //     p1CardIndex.value = value;  // Increment the value if it's a number
        //     console.log('p1Card_Index incremented to:', p1CardIndex.value);

        //     // tester.rive?.play('Draw'); // Play the specific animation by name
        // } else {
        //     console.error('p1Card_Index is not a number');
        // }

    }, [p1DrewCard]);
    
    
    useEffect(() => {
        // Add event listener for keydown
        window.addEventListener('keydown', handleSpacebarPress);
    
        // Cleanup event listener on component unmount
        return () => {
          window.removeEventListener('keydown', handleSpacebarPress);
        };
      }, []);
    
      const handleSpacebarPress = (event: KeyboardEvent) => {
        if (event.code === 'Space') {
          console.log('Spacebar pressed!');
          SendTakeTurn(0);
        }
      };
      

    // Helper functions
    const findCardByUnicodeIcon = (icon: string) => {
        if (!cardData || !cardData.cards) return null; // Make sure cardData is loaded
        return cardData.cards.find(card => card.icon === icon);
    };

    const getOpponentState = (state: GameState) => {
        let stateValue = 0; // King is neutral
        switch (state.roundWinner) {
            case "Player 1":
                stateValue = 1 // King is mad
                if( state.p2LastCards.length > 1 ) {
                    stateValue = 3; // King is sad casue he lost war
                }
                break;
            case "Player 2":
                stateValue = 2; // King is happy
                if( state.p2LastCards.length > 1 ) {
                    stateValue = 4; // King is Very Happy Cause he won war
                }      
                break;
            default:
        }
        // Check if game is over
        if (state.gameOver) {
            // Check who won the game
            if( state.gameWinner === "Player 1" ) {
                stateValue = 3; // King is sad
            } else if ( state.gameWinner === "Player 2" ) { 
                stateValue = 4; // King is Very Happy (should be celebrating)
            }
        }
        return stateValue;
    };

    const getOpponentSpeachState = (state: GameState) => {
        let stateValue = 0; // King is neutral
        switch (state.roundWinner) {
            case "Player 1":
                stateValue = 1 // King is mad
                if( state.p2LastCards.length > 1 ) {
                    stateValue = 3; // King is sad casue he lost war
                }
                break;
            case "Player 2":
                stateValue = 2; // King is happy
                if( state.p2LastCards.length > 1 ) {
                    stateValue = 4; // King is Very Happy Cause he won war
                }      
                break;
            default:
        }
        // Check if game is over
        if (state.gameOver) {
            // Check who won the game
            if( state.gameWinner === "Player 1" ) {
                stateValue = 5; // King is sad
            } else if ( state.gameWinner === "Player 2" ) {
                stateValue = 6; // King is Very Happy (should be celebrating)
            }
        }
        return stateValue;
    };

    const getWinnerState = (state: GameState) => {
        let value = 0;
        if (state.gameOver) {
            if( state.gameWinner !== "" ) {
                console.log("Game Winner: ", state.gameWinner);
                
                if( state.gameWinner === walletAddress ) {
                    value = 1;
                }
                
                if( state.gameWinner === GAME_PROCESS ) {
                    value = 2;
                }
            }
        } else {
            value = 0;
        }
        return value;
    };

    const [imageAssets, setImageAssets] = useState<string[]>([]);
    const sixDiamonds = "https://jvmn5zijz5fidaguz2tnh5zzobw2svkoz64sfit2ecvoluzu4tya.arweave.net/TVje5QnPSoGA1M6m0_c5cG2pVU7PuSKieiCq5dM05PA";

    useEffect(() => {
        if (imageAssets.length > 0) {
          console.log('List of image assets:', imageAssets);
        }
      }, [imageAssets]);


      const onRiveEventReceived = (riveEvent : any ) => {
        const eventData = riveEvent.data;
        switch (eventData.name) {
          case "DrawEvent":
            console.log("DrawEvent received");

            break;
          default:
            console.log("Unhandled event");
            console.log(riveEvent);
            break;
        }
      };

      const getImage = (asset: ImageAsset) => {
        fetch( sixDiamonds ).then(async (res) => {
          const image = await decodeImage(new Uint8Array(await res.arrayBuffer()));
          asset.setRenderImage(image);
          // You could maintain a reference and update the image dynamically at any time.
          // But be sure to call unref to release any references when no longer needed.
          // This allows the engine to clean it up when it is not used by any more animations.
          image.unref();
        });
      };

      const randomImageAsset = (asset: ImageAsset) => {
        fetch("https://picsum.photos/300/500").then(async (res) => {
          console.log("doing this");
          const image = await decodeImage(new Uint8Array(await res.arrayBuffer()));
          asset.setRenderImage(image);
          // You could maintain a reference and update the image dynamically at any time.
          // But be sure to call unref to release any references when no longer needed.
          // This allows the engine to clean it up when it is not used by any more animations.
          image.unref();
        });
      };
    
      
      // Function to increment the 'p1Card_Index' value
        const incrementP1CardIndex = () => {

            stateMachineInput?.fire();  // Trigger the input if available

            if (p1CardIndex && typeof p1CardIndex.value === 'number') {
                p1CardIndex.value += 1;  // Increment the value if it's a number
                console.log('p1Card_Index incremented to:', p1CardIndex.value);

                tester.rive?.play('Draw'); // Play the specific animation by name
            } else {
                console.error('p1Card_Index is not a number');
            }
        };

        const ForceValue = () => {

            // stateMachineInput?.fire();  // Trigger the input if available
            const value = p1CardIndex?.value;

            if (p1CardIndex && value && typeof p1CardIndex.value === 'number') {
                p1CardIndex.value = value;  // Increment the value if it's a number
                console.log('p1Card_Index incremented to:', p1CardIndex.value);

                // tester.rive?.play('Draw'); // Play the specific animation by name
            } else {
                console.error('p1Card_Index is not a number');
            }
        };

    //     useEffect(() => {
    //         if (tester.rive) {
    //             tester.rive.on(EventType.RiveEvent, onRiveEventReceived);
    //         }
    //     }, [tester.rive]);

    //   const playSpecificAnimation = () => {
    //     if (tester.rive) {

    //         tester.rive.play('Draw'); // Play the specific animation by name
    //     }
    //   };

    const handleButtonClick = () => {
        if (gameState) {

            audioRef.current?.play();

            SendTakeTurn(0); // Call the function to take a turn with choice 0
        } else {
            if (foundGame) {
                console.log("Game already exists");
                SendGetGameState(); // Fetch the game state if it's found
            } else {
                SendTakeTurn(0); // Take a turn with choice 0 if no game is found
            }
        }
    };

    const uplift = () => {
        console.log("Uplift"); 
        
        handleButtonClick();   
    };

    const playMusic = () => {
        if (audioRef.current) {
          audioRef.current.play();
        }
      };
    
    const pauseMusic = () => {
        if (audioRef.current) {
          audioRef.current.pause();
        }
      };

    const getBalanceTest = async () => {
        try {
            const result = await GetBackBalance("repuYDasn9R_A7S-CHONCatzp6FYkQFCwOk4lEtsWUs");
            console.log("Result: " + result);
        } catch (error) {
            console.error("There was an error during the submission process:", error);
        }
      };

    return (
        <>            

            <audio ref={audioRef} src="./audio/Cards_Place_03.wav" />            
            <audio ref={shuffleRef} src="./audio/Cards_Shuffle_1_09.wav" />
            <audio ref={warSfxRef} src="./audio/Weapon_UI_11.wav" />
            <audio ref={winSfxRef} src="./audio/win.wav" />

            {gameState && <Opponent state={ getOpponentState(gameState) } winner={getWinnerState(gameState)}
            speaking={speaking} speachState={getOpponentSpeachState(gameState)} />}
            {gameState && <CardDeck gameState={gameState} uplift={uplift} />}

            
       
            {!isConnected && !turnLoading && (
            <button
                disabled={turnLoading}
                onClick={checkConnected}
                className={`mt-4 px-4 py-2 text-white text-lg font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-opacity-75 ${
                turnLoading
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-amber-500 hover:bg-amber-700 focus:ring-amber-400'
                }`}
            >
                {turnLoading ? 'Loading...' : 'Connect to AO'}
            </button>
            )}
    
            {isConnected && (
                <>
                <AccountInfo />

                    {!gameState && <button
                        onClick={handleButtonClick}
                        className="mt-4 px-4 py-2 left-6 bg-amber-500 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-75"
                    >
                        Start
                    </button> }
                </>
            )}
        </>
    );
    
}

export default Game;
